import { useLazyQuery } from "@apollo/client/react"; import { useEffect, useState } from "react";

import { GET_ALL_NOTIFICATIONS } from '../../../data/graphQL/queries/ResumenIngresoValidation/getAllNotificationsRI';
import { GET_NOTIFICACION_INGRESO_INDICACION } from '../../../data/graphQL/queries/ResumenIngresoValidation/getNotifIngresoIndicacion';
import { GET_NOTIFICACIONES_ASIGNACION } from '../../../data/graphQL/queries/ResumenIngresoValidation/getNotificacionesAsignacion';
import { GET_NOTIFICACIONES_VALIDACION } from '../../../data/graphQL/queries/ResumenIngresoValidation/getNotificacionesValidacion';
import { GET_NOTIFICACIONES_CAMBIO_PROGRAMA } from '../../../data/graphQL/queries/ResumenIngresoValidation/getNotificacionesCambioPrograma';
import { GET_NOTIFICACIONES_CONFIRMAR_EQUIPO } from "../../../data/graphQL/queries/ResumenIngresoValidation/getNotificacionesConfirmarEquipo";
import moment from "moment";

export const useGetDataByTab = ({ filters, activeTabEnum, setNotificaciones, setDatosOriginal }) => {

  const [getAllNotificaciones, allNotificacionesQuery] = useLazyQuery(GET_ALL_NOTIFICATIONS, {
    fetchPolicy: 'no-cache',
  });

  const [getCambioPrograma, cambioProgramaQuery] = useLazyQuery(GET_NOTIFICACIONES_CAMBIO_PROGRAMA, {
    fetchPolicy: 'no-cache',
  });

  const [getConfirmarEquipo, confirmarEquipoQuery] = useLazyQuery(GET_NOTIFICACIONES_CONFIRMAR_EQUIPO, {
    fetchPolicy: 'no-cache',
  });

  const [getAsignacion, asignacionQuery] = useLazyQuery(GET_NOTIFICACIONES_ASIGNACION, {
    fetchPolicy: 'no-cache',
  });

  const [getValidacion, validacionQuery] = useLazyQuery(GET_NOTIFICACIONES_VALIDACION, {
    fetchPolicy: 'no-cache',
  });

  const [getIngreso, ingresoQuery] = useLazyQuery(GET_NOTIFICACION_INGRESO_INDICACION, {
    fetchPolicy: 'no-cache',
  });

  useEffect(() => {
    if (!allNotificacionesQuery?.data) return;

    setNotificaciones(allNotificacionesQuery?.data?.allNotificationsRI?.valorEsperado);
    setDatosOriginal(allNotificacionesQuery?.data?.allNotificationsRI?.valorEsperado);
  }, [allNotificacionesQuery?.data]);

  useEffect(() => {
    if (!cambioProgramaQuery?.data) return;

    setNotificaciones(cambioProgramaQuery?.data?.notificacionesCambioPrograma?.valorEsperado);
    setDatosOriginal(cambioProgramaQuery?.data?.notificacionesCambioPrograma?.valorEsperado);
  }, [cambioProgramaQuery?.data]);

  useEffect(() => {
    if (!confirmarEquipoQuery?.data) return;

    setNotificaciones(confirmarEquipoQuery?.data?.notificacionesConfirmarEquipo?.valorEsperado);
    setDatosOriginal(confirmarEquipoQuery?.data?.notificacionesConfirmarEquipo?.valorEsperado);
  }, [confirmarEquipoQuery?.data]);

  useEffect(() => {
    if (!asignacionQuery?.data) return;

    setNotificaciones(asignacionQuery?.data?.notificacionesAsignacion?.valorEsperado);
    setDatosOriginal(asignacionQuery?.data?.notificacionesAsignacion?.valorEsperado);
  }, [asignacionQuery?.data]);

  useEffect(() => {
    if (!validacionQuery?.data) return;

    setNotificaciones(validacionQuery?.data?.notificacionesValidacion?.valorEsperado);
    setDatosOriginal(validacionQuery?.data?.notificacionesValidacion?.valorEsperado);
  }, [validacionQuery?.data]);

  useEffect(() => {
    if (!ingresoQuery?.data) return;

    setNotificaciones(ingresoQuery?.data?.notificationsRIIndicaciones?.valorEsperado);
    setDatosOriginal(ingresoQuery?.data?.notificationsRIIndicaciones?.valorEsperado);
  }, [ingresoQuery?.data]);

  const runQuery = () => {
    const commonVariables = {
      idDelegacion: filters?.idDelegacion,
      idEstadoValidacion: filters?.estado,
      from: moment(filters?.fechaDesde),
      to: moment(filters?.fechaHasta)
    };

    const indicacionesVariables = {
      ...commonVariables,
      tipoNotificacionFiltro: activeTabEnum
    };

    switch (activeTabEnum) {
      case "ASIGNACION":
        getAsignacion({ variables: commonVariables });
        break;
      case "VALIDACION":
        getValidacion({ variables: commonVariables });
        break;
      case "CONFIRMAR_EQUIPO":
        getConfirmarEquipo({ variables: indicacionesVariables });
        break;
      case "CAMBIO_PROGRAMA":
        getCambioPrograma({ variables: commonVariables });
        break;
      case "CAMBIO_INDICACION":
      case "INGRESO_INDICACION":
        getIngreso({ variables: indicacionesVariables });
        break;
      default:
        break;
    }
  };

  const loading = allNotificacionesQuery.loading ||
    cambioProgramaQuery.loading ||
    confirmarEquipoQuery.loading ||
    asignacionQuery.loading ||
    validacionQuery.loading ||
    ingresoQuery.loading;

  return { runQuery, loading };
};